/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */
export const getValueFromTextNode = (obj: any) => {
  const textNodeName = "#text";
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) {
      obj[key] = obj[key][textNodeName];
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      obj[key] = getValueFromTextNode(obj[key]);
    }
  }
  return obj;
};



// WEBPACK FOOTER //
// ../get-value-from-text-node.ts